import { useEffect, useState } from "react";
import $axios from "../api/accessor";
import { $api } from "../api/api";

export interface SingleDebt {
  hasDebt: boolean;
  message: string | null;
}

export interface DebtStatusResult {
  serviceDebt: SingleDebt;
  orderDebt: SingleDebt;
  isLoading: boolean;
}

export function useServiceDebt(): DebtStatusResult {
  const [serviceDebt, setServiceDebt] = useState<SingleDebt>({ hasDebt: false, message: null });
  const [orderDebt, setOrderDebt] = useState<SingleDebt>({ hasDebt: false, message: null });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    $axios
      .get($api("user_debt_status"))
      .then((res) => {
        setServiceDebt({
          hasDebt: res.data?.service_debt?.has_debt ?? false,
          message: res.data?.service_debt?.message ?? null,
        });
        setOrderDebt({
          hasDebt: res.data?.order_debt?.has_debt ?? false,
          message: res.data?.order_debt?.message ?? null,
        });
      })
      .catch(() => {
        setServiceDebt({ hasDebt: false, message: null });
        setOrderDebt({ hasDebt: false, message: null });
      })
      .finally(() => setIsLoading(false));
  }, []);

  return { serviceDebt, orderDebt, isLoading };
}
